import { motion } from 'framer-motion'
import { Play, Image, Calendar } from 'lucide-react'
import { formatDate } from '../../utils/helpers'

const GalleryCard = ({ gallery, onClick }) => {
  const mediaCount = gallery.media?.length || 0
  const videoCount = gallery.media?.filter(m => m.type === 'video').length || 0
  const imageCount = mediaCount - videoCount

  return (
    <motion.div
      whileHover={{ y: -8 }}
      className="group bg-white rounded-2xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 cursor-pointer"
      onClick={onClick}
    >
      {/* Cover Image */}
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={gallery.coverImage || gallery.media?.[0]?.url || 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600'}
          alt={gallery.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

        {/* Media Count Badge */}
        <div className="absolute top-4 right-4 flex gap-2">
          {imageCount > 0 && (
            <span className="flex items-center gap-1 bg-black/50 backdrop-blur-sm text-white px-3 py-1.5 rounded-full text-sm">
              <Image className="w-4 h-4" />
              {imageCount}
            </span>
          )}
          {videoCount > 0 && (
            <span className="flex items-center gap-1 bg-black/50 backdrop-blur-sm text-white px-3 py-1.5 rounded-full text-sm">
              <Play className="w-4 h-4" />
              {videoCount}
            </span>
          )}
        </div>

        {/* Play Button Overlay for Video */}
        {videoCount > 0 && (
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
              <Play className="w-8 h-8 text-primary-600 ml-1" />
            </div>
          </div>
        )}

        {/* Title Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-xl font-heading font-bold text-white mb-1 line-clamp-2">
            {gallery.title}
          </h3>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <Calendar className="w-4 h-4" />
            {formatDate(gallery.date)}
          </div>
        </div>
      </div>

      {/* Description */}
      {gallery.description && (
        <div className="p-4">
          <p className="text-gray-600 text-sm line-clamp-2">{gallery.description}</p>
        </div>
      )}
    </motion.div>
  )
}

export default GalleryCard
